import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';

/**
 *  Hook that matches `value` instantly when true, but waits `delay` ms before switching to false.
 */
export var useDelayedOffSwitch = function useDelayedOffSwitch(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    if (value) {
      setState(true);
      return;
    }
    var timeout = setTimeout(function () {
      return setState(false);
    }, delay);
    return function () {
      return clearTimeout(timeout);
    };
  }, [value, delay]);
  return state;
};